export interface JsonApiResponse<T> {
  data: T;
  meta?: any;
  links?: any;
  errors?: any;
}

export type FilterRule =
  | 'eq' // equal
  | 'not_eq' // e	not equal
  | 'matches' //	matches with LIKE	e.g. q[email_matches]=%@gmail.com
  | 'does_not_match' //	does not match with LIKE
  | 'matches_any' //	Matches any
  | 'matches_all' //	Matches all
  | 'does_not_match_any' //	Does not match any
  | 'does_not_match_all' //	Does not match all
  | 'lt' //	less than'
  | 'lteq' //	less than or equal'
  | 'gt' //	greater than'
  | 'gteq' //	greater than or equal
  | 'present' //	not null and not empty	Only compatible with string columns. Example: q[name_present]=1 (SQL: col is not null AND col != '')
  | 'blank' //	is null or empty.	(SQL: col is null OR col = '')
  | 'null' //	is null
  | 'not_null' //	is not null
  | 'in' //	match any values in array	e.g. q[name_in][]=Alice&q[name_in][]=Bob
  | 'not_in' //	match none of values in array
  | 'lt_any' //	Less than any	SQL: col < value1 OR col < value2
  | 'lteq_any' //	Less than or equal to any
  | 'gt_any' //	Greater than any
  | 'gteq_any' //	Greater than or equal to any
  | 'lt_all' //	Less than all	SQL: col < value1 AND col < value2
  | 'lteq_all' //	Less than or equal to all
  | 'gt_all' //	Greater than all
  | 'gteq_all' //	Greater than or equal to all
  | 'not_eq_all' //	none of values in a set
  | 'start' //	Starts with	SQL: col LIKE 'value%'
  | 'not_start' //	Does not start with
  | 'start_any' //	Starts with any of
  | 'start_all' //	Starts with all of
  | 'not_start_any' //	Does not start with any of
  | 'not_start_all' //	Does not start with all of
  | 'end' //	Ends with	SQL: col LIKE '%value'
  | 'not_end' //	Does not end with
  | 'end_any' //	Ends with any of
  | 'end_all' //	Ends with all of
  | 'not_end_any'
  | 'not_end_all'
  | 'cont' //	Contains value	uses LIKE
  | 'cont_any' //	Contains any of
  | 'cont_all' //	Contains all of
  | 'not_cont' //	Does not contain
  | 'not_cont_any' //	Does not contain any of
  | 'not_cont_all' //	Does not contain all of
  | 'i_cont' //	Contains value with case insensitive	uses ILIKE
  | 'i_cont_any' //	Contains any of values with case insensitive
  | 'i_cont_all' //	Contains all of values with case insensitive
  | 'not_i_cont' //	Does not contain with case insensitive
  | 'not_i_cont_any' //	Does not contain any of values with case insensitive
  | 'not_i_cont_all' //	Does not contain all of values with case insensitive
  | 'true' //	is true
  | 'array_contains' //	contains value in array
  | 'false';

export interface JsonApiParams {
  filter?: JsonApiFilter;
  fields?: JsonApiFields;
  sort?: JsonApiSort;
  page?: JsonApiPage;
  include?: string;
  [key: string]: any;
}

export interface JsonApiFilter {
  [key: string]: {
    rule?: FilterRule;
    value: string | number | boolean | (string | number | boolean)[];
  };
}

export interface JsonApiFields {
  [key: string]: string[];
}

export type JsonApiSort = string[];

export interface JsonApiPage {
  number: number;
  size: number;
}
